<template lang="pug">
  #app
    router-view
</template>

<script>

export default {
  components: {
  },
  name: 'App',
  created () {
    console.log('APP CREATED')
    this.$store.state.User.axios_active_requests = 0
  },
  methods: {
  },
  computed: {
    isUserAuthenticated: {
      get () {
        return this.$store.state.User.user.id
      }
    },
    networkChosen: {
      get () {
        return this.$store.state.User.networkChosen
      }
    }
  }
}
</script>

<style lang="sass">
@import "sass/app"
</style>



// WEBPACK FOOTER //
// src/App.vue